const PROCESSING_DEAL_LINE_REGEX = /^Processing\s+(\d+)\s+of\s+(\d+)\b/i;
const PROCESSING_DEAL_RANGE_REGEX =
  /^Processing\s+\((\d+)\s*-\s*(\d+)\)\s+out\s+of\s+(\d+)\b/i;

/**
 * Extracts the sort key for a processing deal status line (ascending order).
 * Legacy: "Processing N of M"; batch: "Processing (start - end) out of total".
 * @param {string} line
 * @returns {number|null}
 */
export function getProcessingDealSortKey(line) {
  const text = String(line).trim();
  const rangeMatch = text.match(PROCESSING_DEAL_RANGE_REGEX);
  if (rangeMatch) {
    return Number(rangeMatch[1]);
  }
  const legacyMatch = text.match(PROCESSING_DEAL_LINE_REGEX);
  if (legacyMatch) {
    return Number(legacyMatch[1]);
  }
  return null;
}

/**
 * Highest deal index implied by a processing line (for progress reconciliation).
 * @param {string} line
 * @returns {number|null}
 */
export function getProcessingDealHighWater(line) {
  const text = String(line).trim();
  const rangeMatch = text.match(PROCESSING_DEAL_RANGE_REGEX);
  if (rangeMatch) {
    return Number(rangeMatch[2]);
  }
  const legacyMatch = text.match(PROCESSING_DEAL_LINE_REGEX);
  if (legacyMatch) {
    return Number(legacyMatch[1]);
  }
  return null;
}

/**
 * Sorts multi-line status messages so processing deal lines appear in ascending
 * progress order. Other lines keep their relative order and appear first.
 * @param {string[]} lines
 * @returns {string[]}
 */
export function sortStatusMessageLines(lines) {
  const other = [];
  const processing = [];

  lines.forEach((line, index) => {
    if (line === "") {
      other.push({ line, index });
      return;
    }

    const progressIndex = getProcessingDealSortKey(line);
    if (progressIndex != null) {
      processing.push({ line, index, progressIndex });
    } else {
      other.push({ line, index });
    }
  });

  processing.sort((a, b) => {
    if (a.progressIndex !== b.progressIndex) {
      return a.progressIndex - b.progressIndex;
    }
    return a.index - b.index;
  });

  return [...other, ...processing].map(({ line }) => line);
}
